import React from 'react';

import { PropsWithChildren } from 'react';

export default function Wrapper(props: PropsWithChildren<{}>) {
  return <div className="flex-auto relative max-w-screen-lg " {...props} />;
}
